<template>
  <i
    class="tm-visual-border"
    :class="{
      f: $props.isFirst,
      l: $props.isLast,
      b: $props.showBorder,
      r: $props.replaceStyle,
    }"
    :style="{
      borderLeftWidth: horizontalBorderWidth,
      borderRightWidth: horizontalBorderWidth,
    }"
  />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'tm-visual-border',
  props: {
    isFirst: { type: Boolean, required: true },
    isLast: { type: Boolean, required: true },
    showBorder: { type: Boolean, required: true },
    replaceStyle: { type: Boolean, required: true },
    rectangle: { type: Object, required: true },
  },

  computed: {
    ...mapState('timemachine', {
      pxVisualSpanBorder: (state) => state.cssVariables.pxVisualSpanBorder,
    }),

    horizontalBorderWidth() {
      let rv = `${this.pxVisualSpanBorder}px`;
      if (this.$props.rectangle) {
        if (this.$props.rectangle.width <= 2 * this.pxVisualSpanBorder) {
          rv = `${-0.5 + this.$props.rectangle.width / 2}px`;
        }
      }
      return rv;
    },
  },
};
</script>

<style lang="scss">
.tm-visual-span .tm-visual-border {
  --border-style: solid;
  --border-colour: transparent;

  position: absolute;
  top: 0;
  pointer-events: none;
  z-index: var(--tm-zVisualBorder);

  &.b {
    --border-colour: #{$color-primary};
  }

  &.f {
    border-left: var(--tm-pxVisualSpanBorder) var(--border-style)
      var(--border-colour);
  }

  &.l {
    border-right: var(--tm-pxVisualSpanBorder) var(--border-style)
      var(--border-colour);
  }

  &.r {
    --border-style: dashed;
    --border-colour: var(--tm-replaceColour);
  }

  border-top: var(--tm-pxVisualSpanBorder) var(--border-style)
    var(--border-colour);
  border-bottom: var(--tm-pxVisualSpanBorder) var(--border-style)
    var(--border-colour);
}
</style>
